import React, {Component} from 'react';
import AuthorPopup from "./AuthorPopup";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
// import * as Actions from "../../../../store/modules/resources";
import * as FActions from "../../../../store/modules/footer";
import * as func from "../../../../utils/functions";
import {faUserTimes} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

class resource extends Component {
  constructor(props) {
		super(props);

    this.state = {
      action : 'analytics/resource',
      output_style : 'resource',
      records : [],
      scholar_id: '',
      scholar_name: '',
      publish_year_s: '',
      publish_year_e: '',
      input_date_s: '',
      input_date_e: '',
      sinbun_types: [],
      col_id : '',
      dept_id : '',
      maj_id : '',
      id_type : '',
      ids : '',
      searchScholar: '',
      showAuthorPopup: false,
      searchPopupIndex: '',
      searchPopupTitle: '',
      dept : [],
      deptKeyLabel : {},
      dept_depth1 : [],
      dept_depth2 : [],
      dept_depth3 : [],
      analytics : []
    }
    this.setAuthor = this.setAuthor.bind(this);
    this.getAnalytics = this.getAnalytics.bind(this);
    this.setAuthorPopup = this.setAuthorPopup.bind(this);
    this.showMessage = this.showMessage.bind(this);

    this.sinbunData = [
      {id: 'professor', name: '교수'},
      {id: 'professor_fund', name: '기금교수'},
      {id: 'professor_etc', name: '기타교수'},
      {id: 'professor_hk', name: 'HK교수'},
      {id: 'professor_honor', name: '명예교수'},
      {id: 'professor_hosp', name: '병원교수'},
      {id: 'researcher', name: '연구원'},
      {id: 'resident', name: '전공의'},
      {id: 'lecturer', name: '강사'},
      {id: 'employee', name: '직원'},
      {id: 'assistant', name: '조교'},
      {id: 'postgraduate', name: '대학원생'},
      {id: 'undergraduate', name: '학부생'}
    ]
  }

  componentDidMount() {
    func.getData("category/dept", null).then((response) => {
      const deptKeyLabel = {}
      response.records.map((d, index) => {
        deptKeyLabel[d.category_id] = d.category_name
      })
      this.setState({
        dept : response.records,
        deptKeyLabel : deptKeyLabel
      }, () => {
        this.setDepth();
      })
    })
  }

  setDepth() {
    let depth1 = [];
    let depth2 = [];
    let depth3 = [];

    if (this.state.dept.length > 0) {
      depth1 = this.getChildDepth(0)

      if (this.state.col_id) { depth2 = this.getChildDepth(this.state.col_id) }
      if (this.state.dept_id) { depth3 = this.getChildDepth(this.state.dept_id) }

      this.setState({
        dept_depth1 : depth1,
        dept_depth2 : depth2,
        dept_depth3 : depth3,
      })
    }
  }

  getChildDepth(parent_id) {
    return this.state.dept.filter(f => f.up_category_id == parent_id)
  }

  onChange = (event) => {
    let state = this.state
    state[event.target.name] = event.target.value
    this.setState(state)

    if (event.target.name === 'col_id' ) {
      this.setDepth()
      this.dept_id.value = ''
    }

    if (event.target.name === 'dept_id' ) {
      this.setDepth()
      this.maj_id.value = ''
    }

    this.forceUpdate()
  }

  onKeyPress = (event) => {
    if(event.key === 'Enter') {
      this.setAuthorPopup(true, this.state.searchScholar)
    }
  }

  deleteScholarId() {
    this.setState({
      scholar_id: '',
      scholar_name: '',
      searchScholar: ''
    });
    this.forceUpdate();
    // console.log(this.state);
  }

  showMessage(message) {
    this.props.fDataActions.setFooter({
      'isNoticePopup': true,
      'noticeMessage': message
    })
    setTimeout(() => {
      this.props.fDataActions.setFooter({
        'isNoticePopup': false,
        'noticeMessage': ''
      })
    }, 3000);
  }

  setAuthorPopup(status, ks) {
    if (status) {
      this.setState({
        showAuthorPopup: status,
        searchScholar: ks ? ks : ''
      })
    } else {
      this.setState({
        showAuthorPopup: status,
      })
    }
  }

  setAuthor(record) {
    this.setAuthorPopup(false, '');

    this.setState({
      scholar_name: record.scholar_name,
      scholar_id: record.scholar_id
    });
    this.forceUpdate();
  }

  getAnalytics () {
    let param = {
      'scholar_id': this.state.scholar_id,
      'publish_year_s': this.state.publish_year_s,
      'publish_year_e': this.state.publish_year_e,
      'input_date_s': this.state.input_date_s,
      'input_date_e': this.state.input_date_e,
      'col_id': this.state.col_id,
      'dept_id': this.state.dept_id,
      'maj_id': this.state.maj_id,
      'output_style': this.state.output_style ? this.state.output_style : 'resource',
      'sinbun_types': this.state.sinbun_types,
      'id_type': this.state.id_type ? this.state.id_type : 'school_no',
      'ids': this.state.ids
    }
    // console.log(param)
    func.getData(this.state.action + "/" + 'view' , param).then((response) => {
      // console.log(response)
      let analytics = this.state.analytics
      let analytic = {
        'total' : response.total,
        'condition' : response.condition,
        'summary' : response.summary,
        'request_query' : response.request_query,
      }
      analytics.push(analytic)
      this.setState({
        analytics : analytics,
      })
    })
  }

  checkSinbun = (event, value) => {
    let state = this.state
    // state[event.target.name] = event.target.value
    if(event.target.checked) {
      if (state.sinbun_types.includes(value)) {
      } else {
        state.sinbun_types.push(value)
      }
    } else {
      if (state.sinbun_types.includes(value)) {
        const idx = state.sinbun_types.indexOf(event.target.value)
        if (idx > -1) state.sinbun_types.splice(idx, 1)
      }
    }
    // console.log(state.sinbun_types)
    this.setState(state)
    this.forceUpdate()
  }

  render() {

    return (
        <>
          <div className="card maxWidthInit p-0">
            <div className="card-header">
              연구물 분석
            </div>
            <div className="card-body">
              <div className="row mb-2">
                <div className="col-md-12">
                  <label><strong>출력 스타일</strong>(필수)</label>
                  <div className="input-group mb-2">
                    <div className="form-check form-check-inline mr-3">
                      <input className="form-check-input" type="radio" id="output_style_resource" name="output_style"
                             value="resource"
                             onChange={this.onChange} defaultChecked/>
                      <label className="form-check-label" htmlFor="output_style_resource">논문기준</label>
                    </div>
                    <div className="form-check form-check-inline mr-3">
                      <input className="form-check-input" type="radio" id="output_style_author" name="output_style"
                             value="author"
                             onChange={this.onChange}/>
                      <label className="form-check-label" htmlFor="output_style_author">저자기준</label>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row mb-2">
                <div className="col-md-4">
                  <div className="form-group">
                    <label><strong>연구자 검색</strong></label>
                    <div className="input-group">
                      <input type="text" className="form-control" name="searchScholar"
                             onChange={this.onChange} onKeyPress={this.onKeyPress} />
                      <button type="button" className="btn btn-outline-secondary btn-sm" onClick=
                          {() => this.setAuthorPopup(true, this.state.searchScholar)}>
                        검색
                      </button>
                    </div>
                  </div>
                  {this.state.scholar_name &&
                      <p>
                        <button type="button" id="delete_scholar_id" onClick={() => this.deleteScholarId()}>
                          <FontAwesomeIcon icon={faUserTimes}/>
                        </button>
                        {this.state.scholar_name}({this.state.scholar_id})
                      </p>
                  }
                </div>
                <div className="col-md-4">
                  <div className="form-group">
                    <label><strong>반입일</strong>(yyyy-mm-dd)</label>
                    <div className="input-group">
                      <input type="text" className="form-control" name="input_date_s" onChange={this.onChange} />
                      <span className="input-group-text">~</span>
                      <input type="text" className="form-control" name="input_date_e" onChange={this.onChange} />
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-group">
                    <label><strong>출판년도</strong></label>
                    <div className="input-group">
                      <input type="text" className="form-control" name="publish_year_s" onChange={this.onChange} />
                      <span className="input-group-text">~</span>
                      <input type="text" className="form-control" name="publish_year_e" onChange={this.onChange} />
                    </div>
                  </div>
                </div>
              </div>
              <div className="row mb-2">
                <div className="col-md-12 form-group">
                  <label htmlFor="sinbun_title"><strong>신분</strong>(선택하지 않으면 전체 신분을 포함해서 검색합니다.)</label>
                  <div className="input-group">
                    {this.sinbunData.map((item, idx) => {
                      return (
                          <div key={item.id} className="form-check form-check-inline mr-3">
                            <input className="form-check-input" name="sinbun_types" type="checkbox" id={item.id}
                                   checked={this.state.sinbun_types.includes(item.id)}
                                   value={item.id} onChange={(event) => this.checkSinbun(event, item.id)} />
                            <label className="form-check-label" htmlFor={item.id}>{item.name}</label>
                          </div>
                      )
                    })}
                  </div>
                </div>
              </div>
              <div className="row mt-3">
                <div className="col-md-12">
                  <label htmlFor="dept_title"><strong>학과 세부 선택</strong></label>
                </div>
              </div>
              <div className="row mb-2">
                <div className="col-md-4 form-group">
                  <label htmlFor="col"><strong>단대</strong></label>
                  <div>
                    <select className="form-control form-control-sm"
                            value={this.state.col_id || ""}
                            ref={(ref)=>this.col_id=ref}
                            name="col_id"
                            onChange={this.onChange}>
                      {this.state.dept_depth1.length != 0 ?
                          <option value="">단과 대학를 선택해주세요.</option> :
                          <option value="">단과 대학이 없습니다.</option>}
                      {this.state.dept_depth1.map((type, i) => {
                        return (<option key={type.category_id} value={type.category_id}>{type.category_name}</option>)
                      })}
                    </select>
                  </div>
                </div>
                <div className="col-md-4 form-group">
                  <label htmlFor="col"><strong>학과</strong></label>
                  <div>
                    <select className="form-control form-control-sm"
                            value={this.state.dept_id || ""}
                            ref={(ref)=>this.dept_id=ref}
                            name="dept_id"
                            onChange={this.onChange}>
                      {this.state.dept_depth2.length != 0 ?
                          <option value="">학과를 선택해주세요.</option> :
                          <option value="">하위 학과가 없습니다.</option>}
                      {this.state.dept_depth2.map((type, i) => {
                        return (<option key={type.category_id} value={type.category_id}>{type.category_name}</option>)
                      })}
                    </select>
                  </div>
                </div>
                <div className="col-md-4 form-group">
                  <label htmlFor="col"><strong>전공</strong></label>
                  <div>
                    <select className="form-control form-control-sm"
                            value={this.state.maj_id || ""}
                            ref={(ref)=>this.maj_id=ref}
                            name="maj_id"
                            onChange={this.onChange}>
                      {this.state.dept_depth3.length != 0 ?
                          <option value="">전공을 선택해주세요.</option> :
                          <option value="">하위 전공이 없습니다.</option>}
                      {this.state.dept_depth3.map((type, i) => {
                        return (<option key={type.category_id} value={type.category_id}>{type.category_name}</option>)
                      })}
                    </select>
                  </div>
                </div>
              </div>
              <div className="row mt-3">
                <div className="col-md-12">
                  <label htmlFor="dept_title"><strong>아이디로 검색</strong>(쉼표로 구분)</label>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <div className="input-group mb-2">
                    <div className="form-check form-check-inline mr-3">
                      <strong className="pr-2">아이디 종류</strong>
                      <input className="form-check-input" type="radio" id="id_type_school_no" name="id_type"
                             value="school_no"
                             onChange={this.onChange} defaultChecked/>
                      <label className="form-check-label" htmlFor="id_type_school_no">교직원번호</label>
                    </div>
                    <div className="form-check form-check-inline mr-3">
                      <input className="form-check-input" type="radio" id="id_type_scholar_id" name="id_type"
                             value="scholar_id"
                             onChange={this.onChange}/>
                      <label className="form-check-label" htmlFor="id_type_scholar_id">Scholar ID</label>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row mb-2">
                <div className="col-md-12">
                  <textarea className="form-control vh-20" id="ids" name="ids" defaultValue=""
                            onChange={this.onChange} placeholder="아이디를 쉼표로 구분해 주세요."/>
                </div>
              </div>
            </div>
            <div className="card-footer text-right">
              <button type="button" className="btn btn-primary" onClick={this.getAnalytics}>검색</button>
            </div>
          </div>

          <div className="mt-5">
            <table className="table table-striped table-thin border-bottom">
              <colgroup>
                <col width="400px"/>
                <col width="100px"/>
                <col width="auto"/>
                <col width="80px"/>
              </colgroup>
              <thead>
              <tr>
                <th scope="col">분석조건</th>
                <th scope="col">결과</th>
                <th scope="col">요약</th>
                <th scope="col">액션</th>
              </tr>
              </thead>
              <tbody>
              {this.state.analytics && this.state.analytics.map((record, index) => {
                return(
                    <tr key={index}>
                      <td>{record.condition}</td>
                      <td>{func.getNumberFormat(record.total)}</td>
                      <td>{func.objectToQueryStringShort(record.request_query)}</td>
                      <td><a href={rmVars.restApi + this.state.action + "/" + 'download?' + func.objectToQueryString(record.request_query)} target="_blank" className="btn btn-outline-dark btn-sm">다운로드</a></td>
                    </tr>
                )
              })}
              </tbody>
            </table>
          </div>

        {this.state.showAuthorPopup &&
            <AuthorPopup
                showAuthorPopup={this.state.showAuthorPopup}
                ks={this.state.searchScholar}
                set={this.setAuthor}
                showMessage={this.showMessage}
                setAuthorPopup={this.setAuthorPopup}
            />
        }
        </>
    )

  }
}

export default connect(
  // (state) => ({
    // record: state.resources.record ? state.resources.record : {},
  // }),
  (dispatch) => ({
    // dataActions: bindActionCreators(Actions, dispatch),
    fDataActions: bindActionCreators(FActions, dispatch)
  }),
)(resource)

// export default resource;
